export default "__VITE_ASSET__DJlLT85I__"